import React from 'react'
import {Grid} from '@mui/material';
import {PaymentTitle, TransactionLabel} from '../style'
import {formatMoneyAddDecimalPointAndThousands} from "../../../util/PaymentUtils";
import {formatDateMMDDyyyy} from "../../../util/DateUtils";
import {BookingTransactionType} from "../../constants/securspace-constants";

const TransactionItem = ({ transaction }) => {
  const viewInvoice = () => {
    window.open(`/buyer-invoice/${transaction?.transactionNumber}`);
  };

  // Use recomputed buyer transaction amount if available (payment-method-specific fees)
  // Fall back to transactionGrossAmount (raw service charge without fees) if no payment method selected
  const displayAmount = transaction.recomputedBuyerTransactionAmount !== undefined
    ? transaction.recomputedBuyerTransactionAmount
    : transaction.transactionGrossAmount;

  const formatRange = (startDate, endDate) => {
    if (startDate == null || endDate == null || startDate === '' || endDate === '') return null;
    return `${formatDateMMDDyyyy(startDate)} - ${formatDateMMDDyyyy(endDate)}`;
  };

  const interval1 = formatRange(
    transaction.firstIntervalTransactionStartDate,
    transaction.firstIntervalTransactionEndDate
  );
  const interval2 = formatRange(
    transaction.secondIntervalTransactionStartDate,
    transaction.secondIntervalTransactionEndDate
  );
  const defaultInterval = formatRange(transaction.startDate, transaction.endDate);

  let servicePeriod = '—';
  if (transaction.type === BookingTransactionType.DATE_ADJUST_CHARGE) {
    const parts = [];
    if (interval1) parts.push(`Period 1: ${interval1}`);
    if (interval2) parts.push(`Period 2: ${interval2}`);
    servicePeriod = parts.length ? parts.join(', ') : (defaultInterval || '—');
  } else if (transaction.type === BookingTransactionType.ADD_SPACE_CHARGE) {
    if (interval1 && interval2) servicePeriod = `${interval1} / ${interval2}`;
    else if (interval1) servicePeriod = interval1;
    else if (interval2) servicePeriod = interval2;
    else servicePeriod = defaultInterval || '—';
  } else if (interval1) {
    // firstIntervalTransactionStartDate/EndDate is the actual invoice service period
    // (e.g. the specific billing month). transaction.startDate/endDate reflect the
    // booking's overall span, so only fall back to those when no interval is present.
    servicePeriod = interval1;
  } else if (defaultInterval) {
    servicePeriod = defaultInterval;
  }

  return (
    <Grid container justifyContent='space-between' alignItems='center'>
      <TransactionLabel onClick={viewInvoice}>{transaction.transactionNumber}</TransactionLabel>
      <PaymentTitle>
        {servicePeriod}
      </PaymentTitle>
      <PaymentTitle>{`${formatMoneyAddDecimalPointAndThousands(displayAmount)}`}</PaymentTitle>
    </Grid>
  )
}

export default TransactionItem
